import React from 'react'

import { Container, Row, Col } from 'react-bootstrap';
import { useGetSagieProductsQuery } from '../../slices/productsApiSlice';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import Skeleton from 'react-loading-skeleton';

import Meta from '../../components/Meta';
import ShoppingProduct from '../../components/ShoppingProduct';

const SITE = 'https://tamratdates.com';

const FAQ_AR = [
  { q: 'ما الذي يميّز التمر الصقعي؟', a: 'يتميّز بلونين وقوامين في الثمرة الواحدة؛ طرفه الذهبي مقرمش وقاعدته البنية طرية، ما يمنحه تجربة فريدة.' },
  { q: 'أين يُزرع التمر الصقعي؟', a: 'يُزرع في منطقة القصيم ووسط السعودية، المعروفة بجودة تمورها.' },
  { q: 'هل التمر الصقعي شديد الحلاوة؟', a: 'حلاوته متوازنة وطعمه غني، وهو غني بالألياف، ويناسب من يحب التوازن لا الإفراط في الحلاوة.' },
  { q: 'كيف أحفظ التمر الصقعي؟', a: 'احفظه في مكان بارد وجاف، أو في الثلاجة للحفاظ على قوامه ونضارته.' },
];
const FAQ_EN = [
  { q: 'What makes Sagai distinctive?', a: 'It has two colours and two textures in one fruit — a crunchy golden tip and a soft brown base — giving a uniquely contrasting bite.' },
  { q: 'Where is Sagai grown?', a: 'It is grown in the Qassim region and central Saudi Arabia, known for the quality of its dates.' },
  { q: 'Are Sagai dates very sweet?', a: 'Their sweetness is balanced and their flavour rich, and they are high in fibre — ideal for those who prefer balance over intense sweetness.' },
  { q: 'How do I store Sagai dates?', a: 'Keep them in a cool, dry place, or refrigerate to preserve their texture and freshness.' },
];

function SagieDates() {

  const { t , i18n } = useTranslation();
  const en = i18n.language === 'en';

    const { data, isLoading, error } = useGetSagieProductsQuery();

  const url = `${SITE}/sagie-date`;
  const faq = en ? FAQ_EN : FAQ_AR;
  const schema = [
    {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: en ? 'Home' : 'الرئيسية', item: `${SITE}/` },
        { '@type': 'ListItem', position: 2, name: en ? 'Sagai Dates' : 'تمر الصقعي', item: url },
      ],
    },
    {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faq.map((f) => ({
        '@type': 'Question',
        name: f.q,
        acceptedAnswer: { '@type': 'Answer', text: f.a },
      })),
    },
  ];

    if(isLoading) {
      return(
      <div>
   <div className='d-flex text-center align-items-center p-5 pb-0 gap-1 ml-5'>
   <Skeleton width={150} />
   </div>
      <h1 className="title">
         <Skeleton width={150} />
      </h1>
        <Row className="py-5">
        <Col sm={4} className="mb-2"><Skeleton height={250} width={350} /></Col>
        <Col sm={4} className="mb-2"><Skeleton height={250} width={350} /></Col>
        <Col sm={4} className="mb-2"><Skeleton height={250} width={350} /></Col>
        <Col sm={4} className="mb-2"><Skeleton height={250} width={350} /></Col>
        <Col sm={4} className="mb-2"><Skeleton height={250} width={350} /></Col>
        <Col sm={4} className="mb-2"><Skeleton height={250} width={350} /></Col>
        </Row>
    </div>
      )
    }

  return (
    <div>
      {en ? (
        <>
          <Meta
            title={'Sagai Dates — Two-Texture Premium Dates | Tamrat'}
            description={'Buy premium Sagai (Saqai) dates online from Tamrat — a unique two-colour, two-texture date: crunchy golden tip, soft brown base, balanced sweetness. Delivery across Saudi Arabia.'}
            url={url}
            type={'website'}
            schema={schema}
          />
          <div className='d-flex text-center align-items-center p-5 pb-0 gap-1 ml-5'>
            <Link to={'/'}><span className='text-decoration-underline'>Home</span></Link>
            <FaAngleRight />
            <span style={{color:'#7C9D64'}}>Sagai Date</span>
          </div>
        </>
      ) : (
        <>
          <Meta
            title={'تمر صقعي فاخر — بلونين وقوامين | تمرات'}
            description={'اشترِ التمر الصقعي الفاخر من تمرات: لونان وقوامان في الثمرة الواحدة، طرف مقرمش وقاعدة طرية، وحلاوة متوازنة وغنى بالألياف. توصيل سريع لكل مناطق السعودية.'}
            url={url}
            type={'website'}
            schema={schema}
          />
          <div className='d-flex text-center align-items-center p-5 pb-0 gap-1 ml-5'>
            <Link to={'/'}><span className='text-decoration-underline'>الرئيسية</span></Link>
            <FaAngleLeft />
            <span style={{color:'#7C9D64'}}>تمر الصقعي</span>
          </div>
        </>
      )}

      <h1 className="title">{t('sagieTitle')}</h1>
      <Container>
        <Row className="py-5">
        { error ? (
        <div>{error?.data.message || error.error}</div>
      ) : (
        data.products.map((product) => (
          <Col sm={4} key={product.id} className='mb-4 p-4'>
         <ShoppingProduct product={product} />
        </Col>
         ))
             )}
        </Row>
      </Container>

      <Container className="pb-5" dir={en ? 'ltr' : 'rtl'} style={{ maxWidth: 900, lineHeight: 1.9, color: '#3d3d3d' }}>
        {en ? (
          <div>
            <h2 style={{ color: '#7C9D64' }}>What is Sagai?</h2>
            <p>Sagai (Saqai) is a distinctive date with <strong>two colours and two textures in a single fruit</strong>: a crunchy golden tip and a soft brown base. Its sweetness is balanced and its flavour rich, and it is high in fibre. It's grown in the Qassim region of central Saudi Arabia and is loved for its unique contrasting bite.</p>
            <h2 style={{ color: '#7C9D64' }}>How to enjoy Sagai dates</h2>
            <ul>
              <li>For the unique two-texture experience.</li>
              <li>With Arabic coffee.</li>
              <li>As a refined everyday choice.</li>
              <li>For those who prefer balanced sweetness.</li>
            </ul>
            <h2 style={{ color: '#7C9D64' }}>Nutrition</h2>
            <p>Sagai dates are a natural source of energy, fibre and potassium. <em>Values are approximate and vary by size and ripeness; for any specific diet, consult a specialist.</em></p>
            <h2 style={{ color: '#7C9D64' }}>Who it's for</h2>
            <p>For those who enjoy a contrast of textures and a balanced, rich sweetness.</p>
            <h2 style={{ color: '#7C9D64' }}>Frequently asked questions</h2>
            {FAQ_EN.map((f, i) => (<div key={i}><h3 style={{ fontSize: 18 }}>{f.q}</h3><p>{f.a}</p></div>))}
          </div>
        ) : (
          <div>
            <h2 style={{ color: '#7C9D64' }}>ما هو التمر الصقعي؟</h2>
            <p>الصقعي نوع مميّز يجمع <strong>لونين وقوامين في الثمرة الواحدة</strong>: طرف ذهبي مقرمش وقاعدة بنية طرية. حلاوته متوازنة وطعمه غني، وهو غني بالألياف. يُزرع في منطقة القصيم وسط السعودية، ويحبّه كثيرون لتجربته الفريدة بتباين القوام.</p>
            <h2 style={{ color: '#7C9D64' }}>كيف تستمتع بالتمر الصقعي؟</h2>
            <ul>
              <li>لتجربة القوامين الفريدة.</li>
              <li>مع القهوة العربية.</li>
              <li>خيار يومي مميّز.</li>
              <li>لمن يفضّل الحلاوة المتوازنة.</li>
            </ul>
            <h2 style={{ color: '#7C9D64' }}>القيمة الغذائية</h2>
            <p>التمر الصقعي مصدر طبيعي للطاقة والألياف والبوتاسيوم. <em>القيم تقريبية وتختلف حسب الحجم ودرجة النضج؛ ولأي نظام غذائي خاص يُنصح باستشارة مختص.</em></p>
            <h2 style={{ color: '#7C9D64' }}>لمن يناسب؟</h2>
            <p>لمن يستمتع بتباين القوام وبالحلاوة المتوازنة الغنية.</p>
            <h2 style={{ color: '#7C9D64' }}>الأسئلة الشائعة</h2>
            {FAQ_AR.map((f, i) => (<div key={i}><h3 style={{ fontSize: 18 }}>{f.q}</h3><p>{f.a}</p></div>))}
          </div>
        )}
      </Container>
    </div>
  )
}

export default SagieDates
